import { useState } from "react";
import { Dialog, DialogContent, IconButton } from "@mui/material";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import type { User } from "@packsize/identity-api-sdk";

import NewUser from "@/views/configuration/users/new-user";

interface EditUserButtonProps {
	readonly user: User;
}

export const EditUserButton = ({ user }: EditUserButtonProps) => {
	const [open, setOpen] = useState(false);

	return (
		<>
			<IconButton onClick={() => setOpen(true)} data-pendoid="users__button__edit-users">
				<EditOutlinedIcon />
			</IconButton>
			<Dialog
				maxWidth="lg"
				fullWidth
				disableEscapeKeyDown
				open={open}
				onClose={(_, reason) => {
					if (reason !== "backdropClick") {
						setOpen(false);
					}
				}}
			>
				<DialogContent sx={{ p: 0 }}>
					<NewUser user={user} closeModal={() => setOpen(false)} />
				</DialogContent>
			</Dialog>
		</>
	);
};
